import $ from "jquery";

const checkout = {
    showDeliveryOptions(e) {
        e.closest(".lux-delivery-options-wrapper").classList.add("active");
    },
};

window.checkout = checkout;

$(document).on("click", "a.go-to-payment", (event) => {
    if ($(".checkbox-accept-order").is(":checked")) {
        $("input.payment-submit-button").trigger("click");
    } else {
        event.preventDefault();
        const el = document.querySelector("header");

        if (!el) {
            return;
        }

        $("input.payment-submit-button").trigger("click");
        $("html, body").animate(
            {
                scrollTop:
                    $(".lux-content-wrapper.accept-order").offset().top -
                    el.offsetHeight -
                    48,
            },
            300,
        );
    }
});

$(document).on("click", ".buy-box-details", function (event) {
    event.preventDefault();

    $(this).removeClass("active");
    $(this).siblings(".buy-box-details").addClass("active");
    $(this).parents(".buy-box").toggleClass("collapsed");
});
